// extracted by mini-css-extract-plugin
export default {"cell":"TableHeadComponent_cell__aWxL8","wrapText":"TableHeadComponent_wrapText__2E09d","footnote":"TableHeadComponent_footnote__KnCX+"};